
import NoData from '@/components/NoData';
import styles from './index.less';
import { List, PullRefresh } from 'react-vant';
import { history, useModel } from '@umijs/max';
import { useEffect, useRef, useState } from 'react';
import { getWechatVote } from '@/service/banner';
import { EyeO } from '@react-vant/icons';
import dayjs from 'dayjs';
// import sUrl1 from '@/assets/home/s2.png';

const VoteList = (props: any) => {
  const { type } = props;
  const [isEmpty, setIsEmpty] = useState(false);
  const formatStatus = (item: any) => {
    if (item.response === '1') {
      return '已提交';
    } else if (item.endFlag === '1' ) {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };
  const [WechatVote , setWechatVote ] = useState([]);
  const pageNum  = useRef(1);
  const {defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );

  console.log('defaultRoom', defaultRoom)

  const click = (item: any) => {
    console.log(item);
    history.push(`/voteDetail?sequenceNbr=${item.sequenceNbr}`);
  };
  const [refreshing, setRefreshing] = useState(false);
  const [finished, setFinished] = useState<boolean>(false)

  // const onLoadRefresh = async (isRefresh: boolean | undefined) => {
  //   setWechatVote ([])
  //   /**
  //    * type: 1 全部 2 进行中 3 已提交
  //    * endStatus = 0 进行中；
  //    * endStatus = 1已结束；
  //    * endStatus = 2已提交；
  //    * endStatus = 其他值 全部； 
  //    * 
  //    */
  //   const endStatus = type === 2 ? 0 : type === 3 ? 2 : undefined;
  //   const data = await getWechatVote({ pageNum: pageNum.current, pageSize: 10, endStatus, type: 1, communityId: defaultRoom?.communityId, floorId: defaultRoom?.floorId })
  //   const listData: any =  [...WechatVote , ...data.rows]
  //   if (isRefresh || pageNum.current === 1) {
  //     setWechatVote (data.rows); 
  //   } else {
  //     setWechatVote (listData);
  //   }
 
  //   if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
  //     setFinished(true);
  //   } else {
  //     pageNum.current = pageNum.current + 1
  //     setFinished(false); // 仍有数据可加载，保持为false
  //   }
  // }

  // const onRefresh = async () => {
  //   pageNum.current = 1
  //   setFinished(true)
  //   setWechatVote ([])
  //   onLoadRefresh(true)
  // }

  const loadData = async (isRefresh = false) => {
    const endStatus = type === 2 ? 0 : type === 3 ? 2 : undefined;
    const data = await getWechatVote({ pageNum: pageNum.current, pageSize: 10, endStatus, type: 1, communityId: defaultRoom?.communityId, floorId: defaultRoom?.floorId })
    console.log(77, data, isRefresh)
    if(data.total === 0 && isRefresh) {
      setWechatVote ([])
      setIsEmpty(true);
      setFinished(true);
      return
    } else {
      setIsEmpty(false)
    }
    
    const listData: any =  [...WechatVote , ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setWechatVote (data.rows); 
    } else {
      setWechatVote (listData);
    }
  
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      if(listData.length === 0 ) {
        setIsEmpty(true);
        setFinished(true);
      } else {
        setIsEmpty(false)
      }
      setFinished(true);
    } else {
      setIsEmpty(false);
      setFinished(false);
      pageNum.current = pageNum.current + 1
    }
  }


  // 下拉刷新处理
  const onRefresh = async () => {
    pageNum.current = 1;
    setRefreshing(true);
    await loadData(true);
    setRefreshing(false);
  };

  // 上拉加载处理 - 由List组件内部管理loading状态
  const onLoad = async () => {
    console.log(finished, refreshing)
    if (finished || refreshing) return;
    await loadData();
  };
  // useEffect(() => {
  //   // 初始加载数据
  //   loadData(true);
  // }, []);


  const formatStyle = (item: any) => {
    if (formatStatus(item)) {
      let data = formatStatus(item);
      switch(data) {
        case '进行中':
          return styles.statusIng
        case '已结束':
          return styles.statusEnd
        case '已提交':
          return styles.statusSubmit
        case '未开始':
          return styles.statusUnStart
        default:
          return styles.status
      }
    } else {
      return styles.status
    }
  }
 
  return ( 
    <div className= {styles.voteList}>
      <PullRefresh onRefresh={onRefresh} disabled={refreshing}>
      {!isEmpty ?(
        <List finished={finished} onLoad={onLoad} finishedText={!WechatVote ?.length ? '' : '没有更多了'} offset={50}>
          {WechatVote ?.length !== 0 && (
            <>
              {WechatVote .map((item: any) => (
                <div
                  onClick={() => click(item)}
                  className={styles['contentBox']}
                  key={item.sequenceNbr}
                >
                     <div className={formatStyle(item)}>{formatStatus(item)}</div>
                      {/* <div className={styles.imgBox}><img src={sUrl1} alt=""  /></div> */}
                      <div className={styles.rightBox}>
                        <div className={styles.title}>
                          <section>{item.title}</section>
                          {/* <Arrow /> */}
                        </div>
                        
                        <div className={styles.box}>
                          <div className={styles['viewBox']}>
                            <div>{item.publishTime ? item.publishTime : '-'}</div>
                            <div className={styles.boxs}>
                              <EyeO className={styles.icon} />
                              {item.viewCount ? item.viewCount : 0}
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
              ))}
            </>
          )}
        </List>
      )
        : (
          <NoData />
        )}
      </PullRefresh>
    </div>
  )
}

export default VoteList